import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Link, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import store from './reducers/store';
import enUS from 'antd/lib/locale-provider/en_US';
import router from './router';
import registerServiceWorker from './registerServiceWorker';
import './combinedStyles';
import HttpInterceptor from './utilities/http.interceptor';

AWS = require('aws-sdk');
AWS.config.region = 'us-east-1';

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={enUS}>{router}</ConfigProvider>
  </Provider>,
  document.getElementById('app')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js